module.exports = __webpack_public_path__ + "img/pt-r-dub.7fe8a333.jpg";